import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ApplicationError = () => {
  const { t } = useTranslation()
  return <Typography variant="body1">{t('viewCreditApplication.error')}</Typography>
}

export default ApplicationError
